function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import { pathOr } from 'ramda';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
var DirectDebitDetailController = /*#__PURE__*/function () {
  function DirectDebitDetailController() {
    _classCallCheck(this, DirectDebitDetailController);
    this.localeKeys = CustomerCareLocaleKeys;

    //https://qa-documentation.ascendon.tv/v17.4/codes.aspx?type=DirectDebitType
    this.directDebitTypes = {
      '1': i18n.translate(this.localeKeys.E_WALLET.DIRECT_DEBIT.TYPE_LABELS.AUSTRIA),
      '2': i18n.translate(this.localeKeys.E_WALLET.DIRECT_DEBIT.TYPE_LABELS.GERMANY),
      '3': i18n.translate(this.localeKeys.E_WALLET.DIRECT_DEBIT.TYPE_LABELS.THE_NETHERLANDS),
      '4': i18n.translate(this.localeKeys.E_WALLET.DIRECT_DEBIT.TYPE_LABELS.SPAIN),
      '5': i18n.translate(this.localeKeys.E_WALLET.DIRECT_DEBIT.TYPE_LABELS.UNITED_KINGDOM)
    };
  }
  return _createClass(DirectDebitDetailController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.detailData) {
        var typeCode = pathOr('', ['Type'], changesObj.detailData.currentValue);
        this.typeLabel = this.directDebitTypes[typeCode];
      }
    }
  }]);
}();
export var DirectDebitDetailComponent = {
  bindings: {
    detailData: '<'
  },
  controller: DirectDebitDetailController,
  template: require('./direct.debit.detail.html')
};